export { useIntercom } from './useIntercom'
export { shutdown as shutdownIntercom, getHash } from './intercom'
